import PaginateModel from "@/model/paginate";
import Quote, { QuoteDTO } from "@/model/quote";
import api from "./api";

interface ResponseInterface {
  data: QuoteDTO[];
  paginate: any;
}

interface QuoteList {
  list: Quote[];
  paginate: PaginateModel;
}

class QuoteApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async getAll(query): Promise<QuoteList> {
    const response = await this.getHttp().get<ResponseInterface>(
      "admin-customer/quotes",
      {
        params: query,
      }
    );
    const list: Quote[] = [];
    response.data.data.map((quoteDto) => list.push(new Quote(quoteDto)));

    const paginate = new PaginateModel(response.data.paginate.Quotes);
    return {
      list,
      paginate,
    };
  }
  async getAllByCustomer(query): Promise<QuoteList> {
    const response = await this.getHttp().get<ResponseInterface>(
      "customer/quotes",
      {
        params: query,
      }
    );
    const list: Quote[] = [];
    response.data.data.map((quoteDto) => list.push(new Quote(quoteDto)));

    const paginate = new PaginateModel(response.data.paginate.Quotes);
    return {
      list,
      paginate,
    };
  }

  async deleteManyById(ids: any): Promise<any> {
    return this.getHttp().post<ResponseInterface>(
      "customer/quotes/delete/many",
      ids
    );
  }
}
export default new QuoteApi();
